import { filterOptions, getNewOptionData } from "../TagsEditor.util";
import formatOptionLabel from "./formatOptionLabel";
import { shouldClosePortaledTagSelectorOnScroll } from "./portaledTagSelectorMenu";

export const tagSelectorControlSelectProps = (p) => ({
  ref: (ref) => {
    if (p.selectorRef) {
      p.selectorRef.current = ref;
    }
  },
  inputId: "tag-selector",
  label: p.label,
  isMulti: p.isMulti,
  autoFocus: true,
  ariaLabel: "Tag selector",
  isLoading: p.loading,
  value: p.existingTagValuesAsOptions,
  defaultValue: p.existingTagValuesAsOptions,
  onChange: p.onChange,
  onBlur: p.onBlur,
  isClearable: false,
  // Backspace in an empty input would remove the last tag with no prompt.
  // Each tag has its own remove button.
  backspaceRemovesValue: false,
  closeMenuOnSelect: false,
  selectType: "creatable",
  defaultInputValue: p.inputValue,
  inputValue: p.typedValue,
  onInputChange: p.handleInputChange,
  onMenuOpen: p.handleMenuOpen,
  onMenuClose: p.handleMenuClose,
  components: p.customComponents,
  updateStyles: p.applySelectStyles,
  onMenuScrollToBottom: p.loadMore,
  menuPlacement: p.menuPlacement,
  menuPortalTarget: p.menuPortalTarget,
  ...tagSelectorSelectBindings(p),
});

export const tagSelectorSelectBindings = (p) => ({
  placeholder: `Type to search ${
    p.isAssociationTag ? "association" : "tag"
  } name or type`,
  options: p.loading ? [] : p.options,
  formatGroupLabel: () =>
    `Create new ${p.isAssociationTag ? "association" : "tag"}`,
  formatOptionLabel: (option, { context }) =>
    formatOptionLabel(option, {
      context,
      showTagTypeHelp: p.showTagTypeHelp,
      onRemoveTag: p.onRemoveTag,
      onEditTag: p.onEditTag,
      onAddTag: p.onAddTag,
      onTagClick: p.onTagClick,
      tagsUpdating: p.tagsUpdating,
      entityType: p.entityType,
    }),
  isValidNewOption: () => false,
  getNewOptionData: (value) =>
    p.isAssociationTag
      ? getNewOptionData(value, p.tagTypesConfig, p.options)
      : {},
  filterOption: (...args) => filterOptions(p.existingTags, ...args),
  menuIsOpen: p.hideDropdown ? false : p.openMenu,
  menuPosition: p.menuPortalTarget ? "fixed" : undefined,
  menuShouldScrollIntoView: !p.menuPortalTarget,
  closeMenuOnScroll: p.menuPortalTarget
    ? shouldClosePortaledTagSelectorOnScroll
    : false,
});
